import { FC, useMemo } from 'react';
import ArrowIcon from 'components/UI/Icon/ArrowIcon';
import {
  ActiveTitle,
  Image,
  InactiveTitle,
  Root,
  TwoColumnGrid,
} from './styled';
import clockIcon from 'assets/vectors/clock.svg';
import Tooltip from 'components/UI/Tooltip';
import { format } from 'date-fns';
type Props = {
  title: string;
  active: boolean;
  setActive: (value: boolean) => void;
  modified?: number;
  infoMessage?: string;
  infoMessageIcon?: string;
  isEditable?: boolean;
  editInfoMessage?: string;
  editIcon?: string;
  onEditClick?: () => void;
};

const AccordionTitle: FC<Props> = ({
  title,
  active,
  setActive,
  modified,
  infoMessage,
  infoMessageIcon,
  isEditable,
  editInfoMessage,
  editIcon,
  onEditClick,
}) => {
  const formatedTitle = useMemo(() => {
    if (active) {
      return <ActiveTitle>{title}</ActiveTitle>;
    }
    return <InactiveTitle>{title}</InactiveTitle>;
  }, [active, title]);

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // This prevents the accordion from toggling
    onEditClick?.();
  };
  return (
    <Root onClick={() => setActive(!active)}>
      {formatedTitle}
      {modified && (
        <TwoColumnGrid>
          {infoMessage && (
            <Tooltip position="left" paragraph={`${infoMessage}`}>
              <Image src={infoMessageIcon} alt="infoMessage" />
            </Tooltip>
          )}
          {isEditable && (
            <Tooltip position="right" paragraph={`${editInfoMessage}`}>
              <Image
                src={editIcon}
                alt="editable"
                onClick={handleEditClick}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          )}
          <Tooltip
            position="bottom"
            paragraph={`Modified: ${format(
              Number(modified),
              'yyyy-MM-dd HH:mm:ss'
            )}`}
          >
            <Image src={clockIcon} alt="modified" />
          </Tooltip>
          <ArrowIcon
            size="small"
            direction={active ? 'up' : 'down'}
            transition={false}
          />
        </TwoColumnGrid>
      )}
      {!modified && (
        <ArrowIcon
          size="small"
          direction={active ? 'up' : 'down'}
          transition={false}
        />
      )}
    </Root>
  );
};

export default AccordionTitle;
